import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	root: {
		height: '100%',
	},
});
